import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1728d12b")
const _hoisted_1 = { class: "col-12 col-sm-6 col-lg-4 col-xl-3" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog fa-2x text-secondary" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.getImgUrl(),
        class: "card-img-top",
        alt: `${_ctx.languageToGerman(_ctx.course.languageTo)}: Kein Bild`,
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectToDetails && _ctx.redirectToDetails(...args)), ["self"]))
      }, null, 8, _hoisted_3),
      _createElementVNode("div", {
        class: "card-body pt-3",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectToDetails && _ctx.redirectToDetails(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.user.type==='teacher')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editCourse', _ctx.course))),
                class: "col-12 text-right pr-0"
              }, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h3", {
            class: "card-title text-primary text-center",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.redirectToDetails && _ctx.redirectToDetails(...args)), ["self"]))
          }, _toDisplayString(_ctx.course.name), 1)
        ])
      ])
    ])
  ]))
}